import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';

const DespatchParticularReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.DESPATCH_PARTICULARS_OVERVIEW.id,
        label: 'OVERVIEW',
      },
      {
        value: ReportDefinitions.DESPATCH_PARTICULARS_RECEPTACLE_TYPE.id,
        label: 'RECEPTACLE TYPE',
      },
      {
        value: ReportDefinitions.DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS.id,
        label: 'FORMAT OF CONTENTS',
      },
      {
        value: ReportDefinitions.DESPATCH_PARTICULARS_CONTENT.id,
        label: 'CONTENTS',
      },
      {
        value: ReportDefinitions.DESPATCH_PARTICULARS_RECEPTACLE_DETAILS.id,
        label: 'RECEPTACLE DETAILS',
      }]
    }
    {...props}
  />
);
export default DespatchParticularReport;

DespatchParticularReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  getTrProps: PropTypes.func,
};
